var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('create-order-detail-status')],1),_c('v-col',{attrs:{"cols":"9"}},[_c('table-order-detail-status')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }